import React from 'react'

function GmailIcon () {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='45.322'
        height='34'
        viewBox='0 0 45.322 34'
      >
        <g
          id='Group_12448'
          data-name='Group 12448'
          transform='translate(-27 -136.001)'
        >
          <path
            id='Path_16298'
            data-name='Path 16298'
            d='M55.09,84.237H62.3V66.726L52,59V81.146a3.089,3.089,0,0,0,3.09,3.09'
            transform='translate(-25 85.764)'
            fill='#4285f4'
          />
          <path
            id='Path_16299'
            data-name='Path 16299'
            d='M120,84.237h7.21a3.089,3.089,0,0,0,3.09-3.09V59L120,66.726'
            transform='translate(-57.979 85.764)'
            fill='#34a853'
          />
          <path
            id='Path_16300'
            data-name='Path 16300'
            d='M120,45.082V58.473l10.3-7.726v-4.12a4.635,4.635,0,0,0-7.416-3.708'
            transform='translate(-57.979 94.018)'
            fill='#fbbc04'
          />
          <path
            id='Path_16301'
            data-name='Path 16301'
            d='M72,61.391V48l12.361,9.271L96.721,48V61.391L84.361,70.661'
            transform='translate(-34.7 91.1)'
            fill='#ea4335'
          />
          <path
            id='Path_16302'
            data-name='Path 16302'
            d='M52,46.627v4.12l10.3,7.726V45.082l-2.884-2.163A4.634,4.634,0,0,0,52,46.627'
            transform='translate(-25 94.018)'
            fill='#c5221f'
          />
        </g>
      </svg>
    </div>
  )
}

export default GmailIcon
